// Import HTTP client
import {
  depositAgreementService,
  initiateDepositService,
  getTransactionsService,
  initiateAchDepositService,
  generateTokenService,
  getPlaidAccountsService,
  plaidDepositService,
  initiateLocalDepositService,
  getTransactionService,
  getDepositsService,
  getWalletAddressesService,
  initiateSwapFundsService,
  generateVirtualAccountService,
  getGBPAccountsService,
  getCurrentAccountService,
  getVirtualAccountRequestsService,
  getVirtualAccountOpeningsService,
  getTransactionReportService,
  getReceiptDetailsService
} from '@/services/transactionsService'
import { SortTimeHandler, sortAmountHandler } from '@/utils/helpers'

/** mutation types */
const set_depositInfo = 'set_depositInfo'
const set_localDepositInfo = 'set_localDepositInfo'
const set_wireTransferType = 'set_wireTransferType'
const set_depositContract = 'set_depositContract'
const set_transactions = 'set_transactions'
const set_currentTransaction = 'set_currentTransaction'
const set_transactionDetails = 'set_transactionDetails'
const set_depositTypeView = 'set_depositTypeView'
const set_achDepositInfo = 'set_achDepositInfo'
const set_achAccessToken = 'set_achAccessToken'
const set_plaidAccounts = 'set_plaidAccounts'
const set_plaidDepositAmount = 'set_plaidDepositAmount'
const set_deposits = 'set_deposits'
const set_walletAddresses = 'set_walletAddresses'
const set_activeFilter = 'set_activeFilter'
const set_depositDetailsType = 'set_depositDetailsType'
const set_swapDetails = 'set_swapDetails'
const set_assetDepositDetails = 'set_assetDepositDetails'
const set_selectedDepositAccountDetails = 'set_selectedDepositAccountDetails'
const set_pendingDepositState = 'set_pendingDepositState'
const set_GBPAccountsData = 'set_GBPAccountsData'
const set_fundAccountActiveView = 'set_fundAccountActiveView'
const set_currentAccountInfo = 'set_currentAccountInfo'
const sort_transactionsTimeData = 'sort_transactionsTimeData'
const sort_transactionsAmountData = 'sort_transactionsAmountData'
const set_virtualAccountRequests = 'set_virtualAccountRequests'
const set_virtualAccountOpenings = 'set_virtualAccountOpenings'
const set_depositedAmountDetails = 'set_depositedAmountDetails'
const set_fundAccountFromTransactions = 'set_fundAccountFromTransactions'
const set_createPaymentLinkFromTransactions =
  'set_createPaymentLinkFromTransactions'
const set_reportLink = 'set_reportLink'
const set_receiptDetails = 'set_receiptDetails'

/** state */
const getDefaultState = () => {
  return {
    fundAccountActiveView: 'deposit',
    fundAccountFromTransactions: false,
    createPaymentLinkFromTransactions: false,
    GBPAccountsData: {
      items: [],
      page: {}
    },
    depositedAmountDetails: {},
    pendingDepositState: false,
    selectedDepositAccountDetails: {},
    depositDetailsType: {},
    assetDepositDetails: {},
    swapDetails: {},
    depositInfo: {},
    localDepositInfo: {},
    wireTransferType: null,
    plaidAccounts: [],
    activeFilter: 'deposit',
    depositContract: null,
    transactions: {
      items: [],
      page: {}
    },
    deposits: {
      items: [],
      page: {}
    },
    currentTransaction: {},
    transactionDetails: {},
    achDepositInfo: '',
    achAccessToken: '',
    depositTypeView: 'depositType',
    plaidDepositAmount: 0,
    walletAddresses: [],
    currentAccountInfo: {
      items: [],
      page: {}
    },
    virtualAccountRequests: [],
    virtualAccountOpenings: [],
    reportLink: '',
    receiptDetails: {}
  }
}
const state = getDefaultState()

/** getters */
const getters = {
  depositInfo: () => state.depositInfo,
  localDepositInfo: () => state.localDepositInfo,
  wireTransferType: () => state.wireTransferType,
  depositContract: () => state.depositContract,
  transactions: () => state.transactions,
  transactionDetails: () => state.transactionDetails,
  virtualAccountRequests: () => state.virtualAccountRequests
}

/** mutations */
const mutations = {
  [set_depositInfo] (state, data) {
    state.depositInfo = data
  },
  [set_fundAccountFromTransactions] (state, data) {
    state.fundAccountFromTransactions = data
  },
  [set_createPaymentLinkFromTransactions] (state, data) {
    state.createPaymentLinkFromTransactions = data
  },
  [set_localDepositInfo] (state, data) {
    state.localDepositInfo = data
  },
  [set_wireTransferType] (state, data) {
    state.wireTransferType = data
  },
  [set_depositContract] (state, data) {
    state.depositContract = data
  },
  [set_transactions] (state, data) {
    state.transactions = data
  },
  [set_deposits] (state, data) {
    state.deposits = data
  },
  [set_transactionDetails] (state, data) {
    state.transactionDetails = data
  },
  [set_currentTransaction] (state, data) {
    state.currentTransaction = data
  },
  [set_depositTypeView] (state, data) {
    state.depositTypeView = data
  },
  [set_achDepositInfo] (state, data) {
    state.achDepositInfo = data
  },
  [set_achAccessToken] (state, data) {
    state.achAccessToken = data
  },
  [set_plaidAccounts] (state, data) {
    state.plaidAccounts = data
  },
  [set_plaidDepositAmount] (state, data) {
    state.plaidDepositAmount = data
  },
  [set_walletAddresses] (state, data) {
    state.walletAddresses = data
  },
  [set_activeFilter] (state, data) {
    state.activeFilter = data
  },
  [set_depositDetailsType] (state, data) {
    state.depositDetailsType = data
  },
  [set_swapDetails] (state, data) {
    state.swapDetails = data
  },
  [set_depositedAmountDetails] (state, data) {
    state.depositedAmountDetails = data
  },
  [set_assetDepositDetails] (state, data) {
    state.assetDepositDetails = data
  },
  [set_selectedDepositAccountDetails] (state, data) {
    state.selectedDepositAccountDetails = data
  },
  [set_pendingDepositState] (state, data) {
    state.pendingDepositState = data
  },
  [set_GBPAccountsData] (state, data) {
    state.GBPAccountsData = data
  },
  [set_fundAccountActiveView] (state, data) {
    state.fundAccountActiveView = data
  },
  [set_currentAccountInfo] (state, data) {
    state.currentAccountInfo = data
  },
  [sort_transactionsTimeData] (state, sortDirection) {
    state.transactions.items = SortTimeHandler(
      state.transactions.items,
      'createdAt',
      sortDirection
    )
  },
  [sort_transactionsAmountData] (state, sortDirection) {
    state.transactions.items = sortAmountHandler(
      state.transactions.items,
      'amount',
      sortDirection
    )
  },
  [set_virtualAccountRequests] (state, data) {
    state.virtualAccountRequests = data
  },
  [set_virtualAccountOpenings] (state, data) {
    state.virtualAccountOpenings = data
  },

  [set_reportLink] (state, data) {
    state.reportLink = data
  },
  [set_receiptDetails] (state, data) {
    state.receiptDetails = data
  },
  resetState (state) {
    Object.assign(state, getDefaultState())
  }
}

const actions = {
  getCurrentAccountInfo: ({ commit }, payload) => {
    return getCurrentAccountService(payload).then((response) => {
      commit('set_currentAccountInfo', response.data.data || [])
    })
  },
  setFundAccountView: ({ commit }, payload) => {
    commit('set_fundAccountActiveView', payload)
  },
  setDepositedAmountDetails: ({ commit }, payload) => {
    commit('set_depositedAmountDetails', payload)
  },
  setFundAccountFromTransactions: ({ commit }, payload) => {
    commit('set_fundAccountFromTransactions', payload)
  },
  setCreatePaymentLinkFromTransactions: ({ commit }, payload) => {
    commit('set_createPaymentLinkFromTransactions', payload)
  },
  setDepositInfo: ({ commit }, payload) => {
    commit('set_depositInfo', payload)
  },
  resetTransactionsState ({ commit }) {
    commit('resetState')
  },
  getGBPAccounts: ({ commit }) => {
    return getGBPAccountsService().then((response) => {
      commit('set_GBPAccountsData', response.data.data || [])
    })
  },
  depositAgreement: ({ commit }, payload) => {
    return depositAgreementService(payload).then((response) => {
      commit('set_depositContract', response.data.data.htmlContent)
    })
  },
  getPlaidAccounts: ({ commit }, payload) => {
    return getPlaidAccountsService(payload).then((response) => {
      commit('set_plaidAccounts', response.data.data || [])
    })
  },
  plaidDeposit: ({ commit }, payload) => {
    return plaidDepositService(payload).then(() => {})
  },
  initiateDeposit: ({ commit }, payload) => {
    return initiateDepositService(payload).then((response) => {
      commit(
        'set_depositInfo',
        response.data.data.depositRequest.transferInstruction
      )
      commit('set_transactionDetails', response.data.data.depositRequest)
    })
  },
  initiateLocalDeposit: ({ commit }, payload) => {
    return initiateLocalDepositService(payload).then((response) => {
      commit('set_localDepositInfo', response.data.data.details)
    })
  },
  initiateSwapFunds: ({ commit }, payload) => {
    return initiateSwapFundsService(payload)
  },
  initiateAchDeposit: ({ commit }, payload) => {
    return initiateAchDepositService(payload).then((response) => {
      commit('set_achDepositInfo', response.data.data)
    })
  },
  generatePlaidAccessToken: ({ commit }, payload) => {
    return generateTokenService(payload).then((response) => {
      commit('set_achAccessToken', response.data.data)
    })
  },
  resetLocalDepositInfo: ({ commit }, payload) => {
    commit('set_localDepositInfo', payload)
  },
  setTransactionDetails: ({ commit }, payload) => {
    commit('set_transactionDetails', payload)
  },
  setPendingDepositState: ({ commit }, payload) => {
    commit('set_pendingDepositState', payload)
  },
  setCurrentTransaction: ({ commit }, payload) => {
    commit('set_currentTransaction', payload)
  },
  setLocalDepositInfo: ({ commit }, payload) => {
    commit('set_localDepositInfo', payload)
  },
  setPlaidDepositAmount: ({ commit }, payload) => {
    commit('set_plaidDepositAmount', payload)
  },
  activeFilter: ({ commit }, payload) => {
    commit('set_activeFilter', payload)
  },
  setDepositDetailsType: ({ commit }, payload) => {
    commit('set_depositDetailsType', payload)
  },
  setSelectedAccountDepositDetails: ({ commit }, payload) => {
    commit('set_selectedDepositAccountDetails', payload)
  },
  setDepositTypeView: ({ commit }, payload) => {
    commit('set_depositTypeView', payload)
  },
  getTransactions: ({ commit }, payload) => {
    return getTransactionsService(payload).then((response) => {
      commit('set_transactions', response.data.data)
    })
  },
  getDeposits: ({ commit }, payload) => {
    return getDepositsService(payload).then((response) => {
      commit('set_deposits', response.data.data)
    })
  },
  getTransactionById: ({ commit }, payload) => {
    return getTransactionService(payload).then((response) => {
      commit('set_transactionDetails', response.data.data)
    })
  },
  getWalletAddresses: ({ commit }, payload) => {
    return getWalletAddressesService().then((response) => {
      commit('set_walletAddresses', response.data.data)
    })
  },
  wireTransferType: (payload, wireTransferType) => {
    return payload.commit('set_wireTransferType', wireTransferType)
  },
  setSwapDetails: ({ commit }, payload) => {
    commit('set_swapDetails', payload)
  },
  setAssetDepositDetails: ({ commit }, payload) => {
    commit('set_assetDepositDetails', payload)
  },
  generateVirtualAccount: ({ commit }, payload) => {
    return generateVirtualAccountService(payload)
  },
  sortTimeHandler: ({ commit }, sortDirection) => {
    commit('sort_transactionsTimeData', sortDirection)
  },
  sortAmountHandler: ({ commit }, sortDirection) => {
    commit('sort_transactionsAmountData', sortDirection)
  },
  getVirtualAccountRequests: ({ commit }, status) => {
    return getVirtualAccountRequestsService(status).then((response) => {
      commit('set_virtualAccountRequests', response.data.data.items || [])
    })
  },
  getVirtualAccountOpenings: ({ commit }, status) => {
    return getVirtualAccountOpeningsService(status).then((response) => {
      commit('set_virtualAccountOpenings', response.data.data.items || [])
    })
  },

  getTransactionReport: ({ commit }, payload) => {
    return getTransactionReportService(payload).then((response) => {
      commit('set_reportLink', response.data.data)
    })
  },
  getReceiptDetails: ({ commit }, payload) => {
    return getReceiptDetailsService(payload).then((response) => {
      commit('set_receiptDetails', response.data.data)
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
